module.exports = require('./fetchWrapAndForget')
